import React from 'react';
import * as S from './style';
import { Label } from 'components';

interface Props {
    title: string;
    children: React.ReactNode;
    required?: boolean;
    option?: React.ReactElement;
}

function ContentsContainer({ title, children, required = false, option }: Props): React.ReactElement {
    return (
        <S.ContentsContainer>
            <S.ContentsTitleWrapper>
                <Label fontStyle={'title_bold'} required={required} contents={title} />
                {option}
            </S.ContentsTitleWrapper>
            {children}
        </S.ContentsContainer>
    );
}

export default ContentsContainer;
